import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const RoleHomeRedirect: React.FC = () => {
  const { isAuthenticated, isLoading, hasRole } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 text-gray-700">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (hasRole(['admin'])) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (hasRole(['editor'])) {
    return <Navigate to="/editor/articles" replace />;
  }

  return <Navigate to="/login" replace />;
};
